module.exports = __webpack_public_path__ + "static/img/vip.46b6730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/vip.png
// module id = Jakh
// module chunks = 57